export const permissionEntityId = (value: any): string =>
  typeof value === 'string' ? value : value?.id || value?._id || '';

const resolveUser = (value: any, users: any[]) => {
  const id = permissionEntityId(value);
  return users.find((user) => permissionEntityId(user) === id) || value;
};

const isDirectManager = (member: any, currentUserId: string, users: any[]) => {
  const resolvedMember = resolveUser(member, users);
  return permissionEntityId(resolvedMember?.reviewer) === currentUserId;
};

export const canManageGoal = (
  goal: any,
  currentUserId: string,
  users: any[],
) => {
  const owner = resolveUser(goal?.assignee, users);
  return (
    permissionEntityId(owner) === currentUserId ||
    isDirectManager(owner, currentUserId, users)
  );
};

export const canUpdateGoalResult = (
  goal: any,
  result: any,
  currentUserId: string,
  users: any[],
) =>
  canManageGoal(goal, currentUserId, users) ||
  permissionEntityId(result?.assignee) === currentUserId;

export const canUpdateGoalActionItem = (
  task: any,
  currentUserId: string,
  users: any[],
) =>
  permissionEntityId(task?.assignee) === currentUserId ||
  permissionEntityId(task?.createdBy) === currentUserId ||
  isDirectManager(task?.assignee, currentUserId, users);

export const canDeleteGoalActionItem = (
  task: any,
  currentUser: any,
  users: any[],
) =>
  currentUser?.role === 'admin' ||
  permissionEntityId(task?.createdBy) === permissionEntityId(currentUser) ||
  isDirectManager(task?.assignee, permissionEntityId(currentUser), users);
